module.exports = __webpack_public_path__ + "static/img/fenghao.37a2b4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/people/fenghao.jpg
// module id = /mOy
// module chunks = 2